const LOOPBACK_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1']);

/**
 * Select the Electron login page from the renderer's actual origin.
 *
 * Feature-branch deployments intentionally use Vite development mode for
 * diagnostics, so build mode cannot distinguish a deployed renderer from a
 * renderer served by the local developer server.
 */
export function resolveElectronHostLoginUrl(
  rendererHostname: string,
  configuredLocalLoginUrl: string,
  marketingBaseUrl: string,
): string {
  if (LOOPBACK_HOSTNAMES.has(rendererHostname.toLowerCase())) {
    return configuredLocalLoginUrl;
  }

  return new URL('host-login', marketingBaseUrl).toString();
}
